var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHumanity({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89.887,
    height: 82.297,
    viewBox: "0 0 89.887 82.297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_7e68605fd7d3bd4df9659e05a2288820",
    "data-name": "7e68605fd7d3bd4df9659e05a2288820",
    transform: "translate(-15.86 -36.14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_175",
    "data-name": "Rectangle 175",
    width: 3.743,
    height: 3.743,
    transform: "translate(96.594 60.47)",
    fill: "#e2eaf4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_176",
    "data-name": "Rectangle 176",
    width: 3.743,
    height: 3.743,
    transform: "translate(96.594 52.984)",
    fill: "#e2eaf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M210.752,145.148H193.3V132.676a6.176,6.176,0,0,1,6.176-6.176h10.842a6.175,6.175,0,0,1,6.176,6.176v12.472Z",
    transform: "translate(-144.235 -73.449)",
    fill: "#247a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M219.231,305.283a4.067,4.067,0,0,1-1.538-6.328l15.173-18.4a9,9,0,0,1,6.844-3.271l11.366-.14.17,16.419-5.444.079-13.339,15.568a13.993,13.993,0,0,1-10.484,4.89l-22.651.236a4.422,4.422,0,0,1-4.467-4.374v-.045a4.422,4.422,0,0,1,4.376-4.422Z",
    transform: "translate(-145.498 -195.896)",
    fill: "#7695f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M319.375,352.393l10.565-11.769a1.871,1.871,0,1,0-2.785-2.5l-10.566,11.769a2.192,2.192,0,0,1-2.5.551,1.871,1.871,0,0,0-2.132.474,4.065,4.065,0,0,0,2.432,3.419A5.932,5.932,0,0,0,319.375,352.393Z",
    transform: "translate(-240.684 -244.961)",
    fill: "#dbf6e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M133.865,45.8a2.786,2.786,0,0,1,2,.82l6.618,6.616a2.808,2.808,0,1,1-3.97,3.971l-2.042-2.042V69.258a2.807,2.807,0,0,1-2.944,2.8,2.858,2.858,0,0,1-2.671-2.882V55.165l-2.042,2.042a2.808,2.808,0,0,1-3.971-3.971l6.618-6.616a2.792,2.792,0,0,1,2-.82Zm-49.188.82a2.789,2.789,0,0,1,2-.82h.395a2.786,2.786,0,0,1,2,.82L95.7,53.235a2.808,2.808,0,0,1-3.97,3.971l-2.042-2.042V69.258a2.807,2.807,0,0,1-2.944,2.8,2.858,2.858,0,0,1-2.671-2.882V55.165L82.03,57.207a2.808,2.808,0,0,1-3.971-3.971Z",
    transform: "translate(-49.89 -7.852)",
    fill: "#494f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M229.435,36.14a5.949,5.949,0,1,1-5.95,5.95A5.949,5.949,0,0,1,229.435,36.14Z",
    transform: "translate(-168.767)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_177",
    "data-name": "Rectangle 177",
    width: 11.697,
    height: 20.587,
    transform: "translate(54.819 71.7)",
    fill: "#494f54"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_178",
    "data-name": "Rectangle 178",
    width: 3.743,
    height: 3.743,
    transform: "translate(92.851 64.213)",
    fill: "#e2eaf4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_179",
    "data-name": "Rectangle 179",
    width: 3.743,
    height: 3.743,
    transform: "translate(92.851 56.727)",
    fill: "#e2eaf4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_180",
    "data-name": "Rectangle 180",
    width: 3.743,
    height: 3.743,
    transform: "translate(23.604 69.828)",
    fill: "#e2eaf4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_181",
    "data-name": "Rectangle 181",
    width: 3.743,
    height: 3.743,
    transform: "translate(23.604 62.342)",
    fill: "#e2eaf4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_182",
    "data-name": "Rectangle 182",
    width: 3.743,
    height: 3.743,
    transform: "translate(19.86 73.571)",
    fill: "#e2eaf4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_183",
    "data-name": "Rectangle 183",
    width: 3.743,
    height: 3.743,
    transform: "translate(19.86 66.085)",
    fill: "#e2eaf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M221.4,166.14a1.872,1.872,0,0,0-1.872,1.872v9.358h3.743v-9.358A1.872,1.872,0,0,0,221.4,166.14Zm-15.5,0a1.872,1.872,0,0,0-1.872,1.872v9.358h3.743v-9.358A1.872,1.872,0,0,0,205.9,166.14Z",
    transform: "translate(-152.949 -105.67)",
    fill: "#dbf6e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M199.051,329.883H169.107a1.872,1.872,0,1,1,0-3.743h29.945a1.872,1.872,0,1,1,0,3.743Z",
    transform: "translate(-123.044 -235.725)",
    fill: "#494f54"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(15.86 81.245)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M47.875,305.283a4.066,4.066,0,0,0,1.538-6.328l-15.173-18.4a9,9,0,0,0-6.844-3.271l-11.366-.14-.17,16.419,5.444.079,13.339,15.568a13.993,13.993,0,0,0,10.484,4.89l22.651.236a4.422,4.422,0,0,0,4.467-4.374v-.045a4.422,4.422,0,0,0-4.376-4.422Z",
    transform: "translate(-15.86 -277.141)",
    fill: "#3666f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M112.46,352.393l-10.565-11.769a1.871,1.871,0,1,1,2.785-2.5l10.565,11.769a2.193,2.193,0,0,0,2.5.551,1.871,1.871,0,0,1,2.132.474,4.065,4.065,0,0,1-2.432,3.419A5.933,5.933,0,0,1,112.46,352.393Z",
    transform: "translate(-85.404 -326.205)",
    fill: "#daf1f9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanity);
export default __webpack_public_path__ + "static/media/humanity.10410b592729f2a2d92c22977003f7ab.svg";
export { ForwardRef as ReactComponent };